(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("homePageService", ["dashboardResource", "messageService", "frameworkService", "$state", homePageService]);
    function homePageService(dashboardResource, messageService, frameworkService, $state) {
        var homePageServiceFactory = {};
        var defaultHomePage = 2;
        if (frameworkService.data.tenantFeatures.dashboard)
            defaultHomePage = 1;
        var getHomePages = function () {
            var homePages = [0];
            if (frameworkService.data.tenantFeatures.dashboard)
                homePages.push(1);
            homePages.push(2);
            homePages.push(3);
            if (frameworkService.data.tenantFeatures.storefront || frameworkService.data.tenantFeatures.catalog)
                homePages.push(4);
            return homePages;
        };
        var getAllPossibleHomePages = function () {
            var pages = [];
            if (frameworkService.data.tenantFeatures.dashboard)
                pages = [1];
            pages = pages.concat([2, 3]);
            if (frameworkService.data.tenantFeatures.storefront || frameworkService.data.tenantFeatures.catalog)
                pages.push(4);
            return pages;
        };
        //var loadHomePage = function () {
        //	if (frameworkService.data.tenant.id === 0) {
        //		$state.go("main.notFound", {}, { location: false });
        //		return;
        //	}
        //	if (!authService.authentication.isAuth) {
        //		var params = $state.params;
        //		//$state.go("main.homePage", $state.params, { location: false });
        //		var url = $location.$$url;
        //		if (url === "/" || url.toLowerCase().match("/en-ca|/fr-ca|/pt-br|/es-es"))
        //			$state.go("main.homePage", params, { location: false });
        //		else
        //			$state.go("main.notFound", {}, { location: false });
        //	} else {
        //		loadSignedInHomePage();
        //	}
        //};
        var loadSignedInHomePage = function () {
            //TODO - PBI - only need to check server for Super Admins. Or should be available in the frameworkService ya?
            //For user's homePage use authService? framework? to store user's homepage'
            dashboardResource.getHomePageViewModel(function (data) {
                goToHomePage(data.homePage === 0 ? frameworkService.data.tenant.defaultHomePageTypeId : data.homePage);
            }, function (error) {
                //messageService.error(error);
            });
        };
        //var changeHomePage = function (newHomePage) {
        //	homePageServiceFactory.homePage = newHomePage;
        //};
        function goToHomePage(homePage) {
            switch (homePage) {
                case 1:
                    if (frameworkService.data.tenantFeatures.dashboard)
                        $state.go("main.dashboard");
                    else
                        goToHomePage(defaultHomePage);
                    break;
                case 2:
                    $state.go("main.myAccount");
                    break;
                case 3:
                    //if (authService.authentication.isLearner)
                    //	$state.go("main.learningPlan");
                    //else
                    //	goToHomePage(defaultHomePage);
                    $state.go("main.learningPlan");
                    break;
                case 4:
                    if (frameworkService.data.tenantFeatures.storefront || frameworkService.data.tenantFeatures.catalog)
                        $state.go("main.storefrontCatalog");
                    else
                        goToHomePage(defaultHomePage);
                    break;
                default:
                    goToHomePage(frameworkService.data.tenant.defaultHomePageTypeId);
                    break;
            }
        }
        homePageServiceFactory.getHomePages = getHomePages;
        homePageServiceFactory.getAllPossibleHomePages = getAllPossibleHomePages;
        //homePageServiceFactory.loadHomePage = loadHomePage;
        homePageServiceFactory.loadSignedInHomePage = loadSignedInHomePage;
        return homePageServiceFactory;
    }
}());
